<template>
  <ModalOperator ref="ModalOperator" class="no-border" type="primary" iconType="md-settings" iconSize="18" text="修改密码" title="您初次登录系统或密码为初始密码，请先设置新密码" :closable="false" customButton>
    <zpa-form ref="Form">
      <zpa-form-group>
        <zpa-text-input
          label="用户名"
          v-model="data.userName"
          required
          readonly
        />
<!--        <zpa-text-input-->
<!--          label="登陆名"-->
<!--          v-model="data.loginName"-->
<!--          readonly-->
<!--          required-->
<!--        />-->
<!--        <zpa-text-input-->
<!--          label="旧密码"-->
<!--          v-model="data.oldpassword"-->
<!--          required-->
<!--        />-->
        <zpa-text-input
          label="新密码"
          v-model="data.newpassword"
          :validators="[comparepwd]"
          validators-message="密码错误或过于简单"
          placeholder="至少八位,必须要保函有大写字母、小写字母 以及特殊字符 @#$!%*? ，例如：Abc@aaaa"
          required
        />
        <zpa-text-input
          label="新密码确认"
          v-model="data.newpasswordconf"
          :validators="[compare]"
          validators-message="与新密码不一致！"
          required
        />
      </zpa-form-group>
    </zpa-form>
    <Button slot="customBtn" type="primary" @click="onSubmit">确定</Button>
  </ModalOperator>
</template>
<script>
import ModalOperatorMixin from '@/components/commons/ModalOperatorMixin'
import { getCurrentuser, changepwd, loginout } from '@/api/login'
import {mapMutations} from 'vuex'

export default {
  name: 'ChangePwd',

  mixins: [
    ModalOperatorMixin,
  ],
  methods: {
    ...mapMutations(['SET_AUTHORIZES']),
    initialize() {
      this.data = {
        oldpassword: 'chushimima',
        newpassword: '',
        newpasswordconf: '',
      }
    },
    async beforeOpen() {
      let _currentuser = await
      getCurrentuser()
      let _data = this.data
      this.data = {..._currentuser.userInfo,
        ..._data
      }
    },

    onSubmit() {
      this.$refs['Form'].validate().then(res => {
        if (res) {
          this.$Spin.show();
          changepwd({...this.data, newPassword: this.data.newpassword, password: this.data.oldpassword}).then(() => {
            this.$Spin.hide();
            this.$Modal.success({title: '提示', content: '修改成功'})
            // this.doOut()
            this.$refs.ModalOperator.close()
          },
          (reason, testData) => {
            this.$Spin.hide();
            this.$Modal.error({title: '提示', content: reason})
          })
        }
      })
    },
    doOut() {
      loginout()
      this.$store.commit('SET_AUTHORIZES', { allAuthorizes: {}, authorizes: {}})
      localStorage.setItem('authorizesInfo', {})
      // 刷新退出
      location.reload();
    },
    comparepwd(value) {
      let zc = /^(?=.*[a-z])(?=.*[A-Z])(?=.*[@#$!%*?&])[A-Za-z\d@#$!%*?&]{8,}$/
      if (!zc.test(value)) {
        // this.$Message.error('密码过于简单')
      }
      return zc.test(value)
    },
    compare(value) {
      return value === this.data.newpassword
    }
  },
}
</script>
<style scoped>
.no-border.ivu-btn{
  border: 1px solid transparent;
}
</style>
